import jsonLdBlog from './blog';
import getJsonLdPosting from './blogPosting';

function getJsonLdBlog({ postsWithUrl }) {
  const blogPost = postsWithUrl?.map((post) =>
    getJsonLdPosting({
      authorName: post?.author?.name,
      url: post.url,
      headline: post.seo?.seo_title || post.metaTitle || post.title,
      description: post.seo?.meta_description || post.metaDescription || post.description,
      image: post.image,
      dateCreated: post.createdAt,
      dateModified: post.updatedAt,
    })
  );

  return {
    ...jsonLdBlog,
    blogPost,
  };
}

export default getJsonLdBlog;
